
import {
  SEND_CODE_REQUEST,
  SEND_CODE_SUCCESS,
  SEND_CODE_FAILURE,
  VERIFY_CODE_REQUEST,
  VERIFY_CODE_SUCCESS,
  VERIFY_CODE_FAILURE,
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  RESET_STAGE,
  CLEAR_MESSAGE
} from "./actionTypes"

const initialState = {
  stage: 1,
  loading: false,
  success: false,
  registrationError: null,
  message: null,
  email: null,
  loggedUser: null,
}

const account = (state = initialState, action) => {
  switch (action.type) {
    case SEND_CODE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        registrationError: null,
        message: null
      }

    case SEND_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        stage: 2,
        email: action.payload.email,
        message: action.payload.message || "Verification code sent.",
      }

    case SEND_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        registrationError: action.payload,
        message: null
      }

    case VERIFY_CODE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        registrationError: null,
        message: null
      }

    case VERIFY_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        stage: 3,
        message: action.payload.message || "Email verified.",
      }

    case VERIFY_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        registrationError: action.payload,
        message: null
      }

    case REGISTER_USER:
      return {
        ...state,
        loading: true,
        success: false,
        registrationError: null,
        message: null
      }

    case REGISTER_USER_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        token: action.payload.token,
        loggedUser: action.payload.userInfo,
        success: true,
        stage: 1,
        registrationError: null,
        message: "Account created successfully.",
      }

    case REGISTER_USER_FAILED:
      return {
        ...state,
        loggedUser: null,
        loading: false,
        success: false,
        registrationError: action.payload
      }

    case RESET_STAGE:
      return {
        ...state,
        stage: 1,
        loading: false,
        success: false,
        registrationError: null,
        loggedUser: null,
        message: null,
        email: null,
      }

    case CLEAR_MESSAGE:
      return {
        ...state,
        loading: false,
        success: false,
        registrationError: null,
        message: null,
      }

    default:
      return state;
  }
};

export default account
